import styled, { css } from 'styled-components';

interface ILogoWrapper {
  $width?: string;
}

export const LogoWrapper = styled.figure<ILogoWrapper>(
  ({ $width }) => css`
    align-items: center;
    display: flex;
    flex: none;
    flex-direction: column;
    margin: 0;
    width: ${$width || '170px'};
  `
);

export const LogoImage = styled.img`
  width: 100%;
  object-fit: cover;
  cursor: pointer;
`;

export const LogoTagline = styled.figcaption(
  ({ theme }) => css`
    color: ${theme.colors.white};
    font-size: 9px;
    letter-spacing: 0.11em;
    line-height: 1.35;
    margin-top: 3px;
    white-space: nowrap;
  `
);
